import React from "react";
import { BlockquoteAuthor } from "@/.storyblok/types/319751/storyblok-components";
import { storyblokEditable, SbBlokData } from "@storyblok/react";
import { renderRichText } from "@/lib/richText";
import Image from "next/image";

interface BlockquoteAuthorProps {
  blok?: BlockquoteAuthor & SbBlokData;
}

const BlockquoteAuthorComponent: React.FC<BlockquoteAuthorProps> = ({ blok }) => {
  if (!blok) return null;

  const { title, quote, author, photo, type, position } = blok;

  if (type === "quote_team") {
    return (
      <div {...storyblokEditable(blok)} className="card-blog-team mb-4">
        <div className="aside">
          {photo?.filename && (
            <Image
              src={photo.filename}
              alt={`Profile image of ${author}`}
              width={150}
              height={200}
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              loading="lazy"
              quality={75}
            />
          )}
          {author && <h3 className="mb-0">{author}</h3>}
          {position && <small>{position}</small>}
        </div>
        <div className="content">
          {quote && (
            <>
              <div dangerouslySetInnerHTML={{
                __html: renderRichText(quote)
              }} />
              <div className="quote">
                <p>{title}</p>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  if (type === "blog_quote") {
    return (
      <div {...storyblokEditable(blok)} className="card-blog-quote">
        <div className="quote-content">
          {photo?.filename && (
            <Image
              src={photo.filename}
              alt={`${author}'s avatar`}
              title={`${author}'s avatar`}
              width={50}
              height={60}
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              loading="lazy"
              quality={75}
            />
          )}
          {quote && (
            <div dangerouslySetInnerHTML={{
              __html: renderRichText(quote)
                .replace(/<a /g, '<a class="text-decoration-underline text-secondary" target="_blank" rel="noopener" ')
            }} />
          )}
        </div>
      </div>
    );
  }


  if (type === "blue_bg") {
    return (
      <div {...storyblokEditable(blok)} className="blog-quote-pullout">
        {photo?.filename && (
          <Image
            src={photo.filename}
            alt={`${author} avatar`}
            width={130}
            height={130}
            className="mt-0 mb-0"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            loading="lazy"
            quality={75}
          />
        )}
        <div>
          {author && (
            <small><strong>{author} Says:</strong></small>
          )}
          {quote && (
            <div className="lead" dangerouslySetInnerHTML={{
              __html: renderRichText(quote)
            }} />
          )}
        </div>
      </div>
    );
  }

  return (
    <div {...storyblokEditable(blok)}>
      {title && <h3 className="mb-3">{title}</h3>}
      <blockquote className="mb-4">
        {quote && (
          <div className="mb-0" dangerouslySetInnerHTML={{ __html: renderRichText(quote) }} />
        )}
        {(author || photo) && (
          <cite>
            {photo?.filename && (
              <Image
                src={photo.filename}
                alt={`${author} Headshot`}
                className="rounded-circle"
                width={24}
                height={24}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                loading="lazy"
                quality={75}
              />
            )}
            {author && ` ${author}`}
          </cite>
        )}
      </blockquote>
    </div>
  );
};

export default BlockquoteAuthorComponent;